import api from "@/lib/api";

export const settingsService = {
  getPublic: () => api.get("/settings/public").then((r) => r.data),
  updateLanding: (payload) => api.put("/admin/landing", payload).then((r) => r.data.landing),
  getBranding: () => api.get("/admin/branding").then((r) => r.data.branding),
  updateBranding: (payload) => api.put("/admin/branding", payload).then((r) => r.data.branding),
  uploadLogo: (file) => {
    const fd = new FormData();
    fd.append("file", file);
    return api.post("/admin/branding/logo", fd, {
      headers: { "Content-Type": "multipart/form-data" },
    }).then((r) => r.data.branding);
  },
  clearLogo: () => api.delete("/admin/branding/logo").then((r) => r.data.branding),
  getDojo: () => api.get("/admin/dojo").then((r) => r.data.dojo),
  uploadDojoTrack: (file) => {
    const fd = new FormData();
    fd.append("file", file);
    return api.post("/admin/dojo/track", fd, {
      headers: { "Content-Type": "multipart/form-data" },
    }).then((r) => r.data.dojo);
  },
  clearDojoTrack: () => api.delete("/admin/dojo/track").then((r) => r.data.dojo),
  getGuide: () => api.get("/admin/guide").then((r) => r.data.guide),
  updateGuide: (patch) => api.put("/admin/guide", patch).then((r) => r.data.guide),
  uploadGuideImage: (file) => {
    const fd = new FormData();
    fd.append("file", file);
    return api.post("/admin/guide/image", fd, {
      headers: { "Content-Type": "multipart/form-data" },
    }).then((r) => r.data.guide);
  },
  clearGuideImage: () => api.delete("/admin/guide/image").then((r) => r.data.guide),
  getExpertMeAi: () => api.get("/admin/expertmeai").then((r) => r.data.expertmeai),
  updateExpertMeAi: (payload) => api.put("/admin/expertmeai", payload).then((r) => r.data.expertmeai),
  getPromos: () => api.get("/admin/promos").then((r) => r.data.promos),
  updatePromos: (promos) => api.put("/admin/promos", { promos }).then((r) => r.data.promos),
};
